<dashboard-dialog-frame class="mentor-sign-up-viewer-dialog" [header]="headerTitle()" [actions]="actions()" [dialogRef]="dialogRef">

	<div class="h-100 px-2 pt-2 d-flex flex-column">
		<readonly-access [readonly]="!dialogDataservice.canEdit()"></readonly-access>

		<kendo-tabstrip class="flex-grow-1">
			<kendo-tabstrip-tab title="Details" [selected]="true">
				<ng-template kendoTabContent>
					<mentor-sign-up-details-part> </mentor-sign-up-details-part>
				</ng-template>
			</kendo-tabstrip-tab>

			<kendo-tabstrip-tab title="Schedule">
				<ng-template kendoTabContent>
					<mentor-sign-up-schedule-part></mentor-sign-up-schedule-part>
				</ng-template>
			</kendo-tabstrip-tab>

		</kendo-tabstrip>
	</div>

</dashboard-dialog-frame>